
/**
 * Utility functions for handling Wealthica callbacks
 */

/**
 * Check if the current URL appears to be a Wealthica callback
 * 
 * @returns boolean
 */
export const isWealthica2Callback = (): boolean => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  
  // Wealthica v2 callback: check for 'institution', 'code', or 'error' only (see docs)
  return params.has('institution') || params.has('code') || params.has('error');
};

/**
 * Extract parameters from the URL that are related to Wealthica callback
 * 
 * @param overrideParams Optional parameters to override URL parameters
 * @returns WealthicaCallbackParams
 */
export const extractWealthica2CallbackParams = (overrideParams?: { 
  code?: string;
  provider?: string;
  state?: string;
  error?: string;
  errorDescription?: string;
}) => {
  // Use URL params as base
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);

  // Start with URL parameters
  const params = {
    code: urlParams.get('code') || urlParams.get('institution') || undefined,
    provider: urlParams.get('provider'),
    state: urlParams.get('state'),
    error: urlParams.get('error'),
    errorDescription: urlParams.get('error_description'),
    // Also look for access_token which is needed for Wealthica API calls
    access_token: urlParams.get('access_token')
  };
  
  // Override with any provided params
  if (overrideParams) {
    Object.assign(params, overrideParams);
  }

  // Verbose logging for all extracted Wealthica callback parameters
  if (typeof window !== 'undefined' && window.console) {
    console.info('[Wealthica Callback] Extracted callback params:', params);
  }

  // Provider parameter is optional in certain flows
  if (!params.provider) {
    if (typeof window !== 'undefined' && window.console) {
      console.warn('[Wealthica Callback] No provider param present. Using default provider.');
    }
  }

  // Note: Store mutations moved to connection handlers for better separation of concerns

  return params;
};
